import React, { useEffect, useState } from 'react';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { IconName, IconSizes, PearlIcon } from 'dbi-pearl-ui-kit';
import { DavidStoreInsertsStyled } from './DavidStoreInserts.style';
import { useTranslation } from 'react-i18next';
import { useStore } from 'stores/Store';
import { ReactComponent as AlertCircle } from 'assets/SVG-Images/Alert-circle.svg';
import { encryptEmail } from 'shared/utils/utils';

const DavidStoreInserts = (props) => {
    const { sectionRef, sectionId } = props;
    const { t } = useTranslation();
    const { authUser } = useStore();
    const [encryptedEmail, setEncryptedEmail] = useState('');

    const email = authUser?.Email;

    useEffect(() => {
        if (email) {
            const encrypted = encryptEmail(email);
            setEncryptedEmail(encrypted);
        }
    }, [email]);

    const insertOrderUrl = `https://printsoflove.com/davids-inserts?id=${encryptedEmail}`;

    return (
        <DavidStoreInsertsStyled ref={sectionRef} id={sectionId}>
            <SectionHeader
                title={t('WebstoreSections.DBStoreInserts.Title')}
                description={t('WebstoreSections.DBStoreInserts.Description')}
            />
            <div className="order-inserts-container">
                <div className="order-inserts-description">
                    <AlertCircle />
                    <a
                        href={insertOrderUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="description-style"
                    >
                        {t('WebstoreSections.DBStoreInserts.OrderInserts')}
                    </a>
                </div>
                <a
                    href={insertOrderUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="description-style"
                >
                    <PearlIcon
                        className="icon-style"
                        size={IconSizes.MD}
                        iconName={IconName.CHEVRON_RIGHT}
                    />
                </a>
            </div>
        </DavidStoreInsertsStyled>
    );
};
export default DavidStoreInserts;
